export default __webpack_public_path__ + "static/media/Image-Win.32dbaf53.png";